export const allTags = `query tags($search: String!, $queryString: String) {  
    tags(page: 1, limit: 100000, orderBy: "0", orderHow: "0", search: $search, queryString: $queryString) {
      id
      slug
      title 
    }
  }
`;
